import { collarProductIsSupportedInCountry, useLocale } from '../contexts/LocaleContext';
import { getUrlPartnerCode } from '../lib/giftWithPurchasePromo';
import { isInAppShop } from '../lib/inAppShop';
import * as types from '../types';
import { showNanoVariant } from '../components/NanoBanner/NanoBanner';
import { showRescueGwaVariant } from '../views/RescueLanding/RescueBanner';
import useHardwareFirstCheckout from './useHardwareFirstCheckout';
import useIsReferralCheckoutV2 from './useIsReferralCheckoutV2';

/**
 * Whether this visitor gets the pick-your-fi shop at `/shop`. Partner, referral, rescue, nano and
 * in-app contexts keep the classic listing at `/products`: partner promos must not mix with the new
 * pricing model, and the in-app shop serves existing members. Mini is the entry tracker, so a market
 * that cannot sell it has no page to show.
 */
export default function useHardwareFirstShop(): boolean {
  const hardwareFirstEnabled = useHardwareFirstCheckout();
  const isReferralV2 = useIsReferralCheckoutV2();
  const { country } = useLocale();

  return (
    hardwareFirstEnabled &&
    !getUrlPartnerCode()?.trim() &&
    !isReferralV2 &&
    !isInAppShop() &&
    !showRescueGwaVariant() &&
    !showNanoVariant() &&
    collarProductIsSupportedInCountry(types.miniCollarId, country)
  );
}
